export default {"src":"/_next/static/media/logo-white-new.aa312a27.svg","height":486,"width":1600,"blurWidth":0,"blurHeight":0};